import { Component, CUSTOM_ELEMENTS_SCHEMA, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormComponentsControlDirective } from '../../../../../../../../shared/directives/forms/form-components-wrapper.directive';
import { AteModalRef } from '@shared/services/ate-modal/ate-modal.ref';

/** Result returned when the user saves a template name. Null indicates cancellation. */
export type SaveTemplateDialogResult = string | null;

@Component({
  selector: 'marketplace-save-template-dialog',
  templateUrl: './save-template-dialog.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, FormComponentsControlDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SaveTemplateDialogComponent {
  private readonly _dialogRef = inject(AteModalRef<SaveTemplateDialogResult>);
  private readonly _destroyRef = inject(DestroyRef);

  readonly form = new FormGroup({
    templateName: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] })
  });

  constructor() {
    this._dialogRef.onCtaClick = () => this.save();
    this._dialogRef.onCancelClick = () => this._dialogRef.close(null);
    this._dialogRef.setCtaDisabled(true);

    this.form.statusChanges.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      this._dialogRef.setCtaDisabled(this.form.invalid);
    });
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this._dialogRef.close(this.form.controls.templateName.value);
  }
}
